// Catalog of documents available for the /build-your-file custom builder.
// IDs must match the CUSTOM_DOC_PRICES map in /app/backend/server.py.

import { Plane, Hotel, FileText, Car, Mail, Map, Shield } from "lucide-react";

export const BUILD_DOCS = [
  {
    id: "flight",
    name: "Flight Reservation with valid PNR",
    short: "Flight Reservation",
    description: "Real GDS booking with verifiable PNR number",
    price: 19,
    icon: Plane,
    emoji: "✈️",
    preview: { title: "Flight Reservation with valid PNR", package_contents: "Verifiable GDS booking" },
  },
  {
    id: "hotel",
    name: "Hotel Booking Confirmation",
    short: "Hotel Booking",
    description: "Verified hotel reservation for your entire stay",
    price: 19,
    icon: Hotel,
    emoji: "🏨",
    preview: { title: "Hotel Booking Confirmation", package_contents: "Verified Booking.com reservation" },
  },
  {
    id: "visa",
    name: "Visa Application Form",
    short: "Visa Application",
    description: "Fully completed Schengen visa application form",
    price: 15,
    icon: FileText,
    emoji: "📋",
    preview: { title: "Visa Application Form", package_contents: "Schengen short-stay (Type C)" },
  },
  {
    id: "car",
    name: "Car Rental Reservation",
    short: "Car Rental",
    description: "Major rental agency confirmation document",
    price: 15,
    icon: Car,
    emoji: "🚗",
    preview: { title: "Car Rental Confirmation", package_contents: "Major rental agency" },
  },
  {
    id: "cover",
    name: "Cover Letter",
    short: "Cover Letter",
    description: "Professionally written consulate cover letter",
    price: 15,
    icon: Mail,
    emoji: "📄",
    preview: { title: "Cover Letter", package_contents: "Consulate-formatted" },
  },
  {
    id: "itinerary",
    name: "Travel Itinerary & Day-by-Day Plan",
    short: "Travel Itinerary",
    description: "Detailed day-by-day travel plan for your trip",
    price: 18,
    icon: Map,
    emoji: "🗺️",
    preview: { title: "Travel Itinerary & Day-by-Day Plan", package_contents: "Detailed day-by-day plan" },
  },
  {
    id: "insurance",
    name: "Travel Insurance (€30,000)",
    short: "Travel Insurance",
    description: "30,000 EUR Schengen-recognized travel insurance",
    price: 25,
    icon: Shield,
    emoji: "🛡️",
    preview: { title: "Travel Insurance (€30,000)", package_contents: "Schengen Area · 30 days" },
  },
];

export const BUILD_DOCS_BY_ID = Object.fromEntries(BUILD_DOCS.map((d) => [d.id, d]));

// Mapping of package -> contained doc ids — used for the "package would be cheaper" hint.
export const PACKAGE_CONTENTS = {
  basic:    { name: "Basic",    price: 39, docs: ["visa", "flight", "hotel"] },
  complete: { name: "Complete", price: 69, docs: ["visa", "flight", "hotel", "car", "cover"] },
  premium:  { name: "Premium",  price: 99, docs: ["visa", "flight", "hotel", "car", "cover", "itinerary", "insurance"] },
};

/** Given a set of selected doc ids + per-applicant total, return the best
    package suggestion (highest saving) — or null if no package fully covers them. */
export function suggestPackage(selectedDocIds, perApplicantTotal) {
  const selectedSet = new Set(selectedDocIds);
  let best = null;
  for (const [, pkg] of Object.entries(PACKAGE_CONTENTS)) {
    const pkgSet = new Set(pkg.docs);
    const isSubset = [...selectedSet].every((id) => pkgSet.has(id));
    if (!isSubset) continue;
    const saving = perApplicantTotal - pkg.price;
    if (saving > 0 && (!best || saving > best.saving)) {
      best = { ...pkg, saving };
    }
  }
  return best;
}
